// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/registry.npmmirror.com+css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#dom[data-v-71c87823] {\r\n  min-width: 100px;\r\n  min-height: 100px;\r\n  height: 100%;\n}\r\n", ""]);
// Exports
module.exports = exports;
